<template>
    <html>
    <body style="position: relative;background: #fff"  v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/agricultural/index">农技服务</a>&gt; <a href="/agricultural/courselist">农技课程</a> &gt; <a href="">课程详情</a>
            </div>
        </div>
        <div class="kecx">
            <div class="da">
                <h2>{{model.name}}（{{chapterName}}）</h2>
                <div class="xia">
                    <div class="shipin">
                        <video class="moviea" poster muted="" :src="$util.img(video)" controls="controls"> 您的浏览器不支持 video 标签。 </video>
                        <img :src="$util.img(model.image)" class="imgplaya" @click="playvideoa()" alt="">
                        <div class="tu" @click="playvideoa()">
                            <img src="@/assets/styles/images/bofang.png" alt="">
                            <p>可免费观看</p>
                        </div>
                    </div>
                    <div class="tab-wrapper">
                        <ul class="tab-menu">
                            <li class="active">课程介绍</li>
                            <li>目录章节</li>
                        </ul>
                        <div class="tab-content">
                            <div>
                                <div class="tab1" v-html="model.remark">
                                </div>
                            </div>
                            <div>
                                <ul class="tab2">
                                    <li v-for="item in model.chapters_list" :key="item.id">
                                        <a :href="'/agricultural/coursedetails?id='+id+'&cid='+item.id" >
                                            <h4>{{item.name}}</h4>
                                            <p>{{item.duration}}</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fu">
                    <p>{{model.click_count}}人观看</p>
                    <p>时长：{{duration}}</p>

                    <a class="shoucang">
                        <div class="img1" style="margin-top:-3px" v-if="!isshow" @click="collection(1)"><img src="@/assets/styles/images/xq4.png" alt=""><span>收藏</span></div>
                        <div class="img1" style="margin-top:-3px" v-if="isshow" @click="collection(0)"><img src="@/assets/styles/images/xq44.png" alt=""><span>已收藏</span></div>
                    </a>
                </div>
            </div>
        </div>

        <section class="section container09">
            <div class="m">
                <div class="news-qh">
                    <div class="videoBox clearfix" style="width: 100%">
                        <div class="sh"> <strong class="title-news">为您 <span>推荐</span></strong> </div>
                        <ul class="content_new">
                            <a :href="'/agricultural/coursedetails?id='+item.id" t="0" v-for="item in recommentList" :key="item.id">
                                <li class="video_item">
                                    <div class="c_img">
                                        <img :src="$util.img(item.image)" class="lazy" data-original="" alt=" " />
                                        <div class="overlay"> <i class="iconfont icon-shipin"></i> </div>
                                    </div>
                                    <div class="c_info">
                                        <h6> <span class="caption">{{item.name}}</span> </h6>
                                        <p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</p>
                                    </div>
                                </li>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </body>
</html>
</template>

<script>
    import { courseDetail } from '@/api/course/course';
    import { courseList } from '@/api/course/course';
    import { Course_Collection } from '@/api/course/course';
    import { getToken } from "@/utils/auth.js";

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                isshow: false,
                id: 0,
                model:{},
                recommentList:[],
                video:'',
                duration:'',
                chapterName:'',
                cid: 0,
                token:'',
            };
        },
        created() {
            this.id = this.$route.query.id;
            this.cid = this.$route.query.cid;
            this.token = getToken();
            this.getdetails();
            this.getrecommentList();
        },
     
        methods: {
            getdetails() {
                courseDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        this.isshow = this.model.iscollection;
                        if(util.isEmpty(this.cid))
                        {
                            this.video = this.model.chapters_list[0].video;
                            this.duration = this.model.chapters_list[0].duration;
                            this.chapterName = this.model.chapters_list[0].name;
                        }
                        else
                        {
                            var _that = this;
                            var list = _that.model.chapters_list.filter(function(item) {
                                return item.id == _that.cid;
                            });
                            if(list.length>0)
                            {
                                _that.video = list[0].video;
                                _that.duration = list[0].duration;
                                _that.chapterName = list[0].name;
                            }
                        }
                        this.loading = false;

                        let wintitle = `${window.document.title}`;
                        let title = wintitle.split('-')
                        window.document.title = this.chapterName + ' - ' + title[1];
                    }
                }).catch(err => {
                    //this.$message.error(err.message);
                    this.loading = false;
                });
            },
            getrecommentList() {
                courseList({
                    recommend: 'true',
                    limit: 8
                }).then(res => {
                    if(res.code == 0) {
                        this.recommentList = res.data;
                    }
                })
            },
            playvideoa() {
                $(".imgplaya,.shipin .tu").hide();
                $('.moviea').show();
                $('.moviea').get(0).play();
            },
            collection(type) {
                if(util.isEmpty(this.token))
                {
                    //this.$message.warning("还未登录，请先登录！");
                    location.href = '/login?redirect=' + this.$route.fullPath;
                    return;
                }
                var params = {};
                var msg = "收藏成功！";
                if(type == 1) {
                    this.isshow = true;
                    params = {id:this.id};
                }
                else {
                    this.isshow = false;
                    params = {id:this.id, iscancel:1};
                    msg = "取消成功！"
                }
                Course_Collection(params).then(res => {
                    if(res.code == 0) {
                        this.$message.success(msg);
                    }
                    else {
                        this.$message.warning(res.message);
                    }
                })
            }
        },

        mounted () {
            $(document).ready(function() {

                var $wrapper = $('.tab-wrapper'),
                    $allTabs = $wrapper.find('.tab-content > div'),
                    $tabMenu = $wrapper.find('.tab-menu li'),
                    $line = $('<div class="line"></div>').appendTo($tabMenu);

                $allTabs.not(':first-of-type').hide();
                $tabMenu.filter(':first-of-type').find(':first').width('100%')

                $tabMenu.each(function(i) {
                    $(this).attr('data-tab', 'tab'+i);
                });

                $allTabs.each(function(i) {
                    $(this).attr('data-tab', 'tab'+i);
                });

                $tabMenu.on('click', function() {

                    var dataTab = $(this).data('tab'),
                        $getWrapper = $(this).closest($wrapper);

                    $getWrapper.find($tabMenu).removeClass('active');
                    $(this).addClass('active');

                    $getWrapper.find('.line').width(0);
                    $(this).find($line).animate({'width':'100%'}, 'fast');
                    $getWrapper.find($allTabs).hide();
                    $getWrapper.find($allTabs).filter('[data-tab='+dataTab+']').show();
                });

            });
        },

    }
</script>
